module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-afl50-mobile.5447301e.png";